import React, { useMemo, useState } from "react";
import useUserDateTime from "hooks/useUserDateTime";
import { useGetInvestigations } from "security-app/hooks/useInvestigationsAPI";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const IS_ARCHIVED = false;
function AssociatedInvestigationsFilter({
  attribute,
  allActiveFilters,
  filter,
  filterValueRenderer,
  onSubmit
}) {
  const [filterQuery, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
  const { userTimezone } = useUserDateTime();
  const { investigations, pagination, loadingInvestigations } = useGetInvestigations(
    {
      ...filterQuery,
      perPage: filterQuery.pageSize,
      orderBy: "name",
      direction: "asc"
    },
    IS_ARCHIVED,
    userTimezone
  );
  const suggestions = useMemo(
    () => [
      { id: null, value: "no investigation" },
      ...investigations.map((investigation) => ({
        id: investigation.id,
        value: investigation.name
      }))
    ],
    [investigations]
  );
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions,
      isLoading: loadingInvestigations,
      total: pagination.total,
      page: pagination.page,
      pageSize: pagination.perPage,
      setSearchParams
    }
  );
}
export default AssociatedInvestigationsFilter;
